import { createContext } from 'react';

interface IDeviceIdentifierContext {
  udiPi?: string;
  udiDi?: string;
  isPending: boolean;
}

const initialValue: IDeviceIdentifierContext = { isPending: true,
};

const DeviceIdentifierContext =
  createContext<IDeviceIdentifierContext>(initialValue);

export default DeviceIdentifierContext;
